import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import {CollaboGrid} from '../component/index';

const CollaboPage = (props) => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Collaborators</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <CollaboGrid />
    </>
  );
};

export default CollaboPage;
